import React, { Component } from "react";
import PropTypes from "prop-types";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import ErrorLayout from "layouts/ErrorLayout";
import { createBrowserHistory } from "history";

const hist = createBrowserHistory();

export default class ErrorBoundary extends Component {
  state = { has_error: false };
  static propTypes = {
    children: PropTypes.element
  };

  componentDidCatch() {
    this.setState({ has_error: true });
  }

  render() {
    if (this.state.has_error) {
      return (
        <Router history={hist} basename="/">
          <Switch>
            <Route
              exact
              path="/error"
              component={ErrorLayout}
              notFoundError={false}
            />
            <Redirect from="/" to="/error" />
          </Switch>
        </Router>
      );
    } else {
      return this.props.children;
    }
  }
}
